import React from 'react';
import { withLocation } from './../Common/withLocation';
import { devitems } from './../Common/Helpers';
import UniqueSelect from './../Common/UniqueSelect';
//import Swal from 'sweetalert2'; 



//import { initializeIsotopeGrid, refreshIsotopeLayout, applyIsotopeFilter, destroyIsotopeGrid } from './../Elements/customFiltros';


//const GRID_SELECTOR = '.isotope-grid-container';
const GRID_SELECTOR = '.masonry-outer';
var bgimg1 = require('./../../images/background/bg-4.png');


class SearchableGrid extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            // Datos originales (se cargan todos desde el JSON)
            allProjects: props.data || devitems,
            loading: false,

            // Estado del formulario (filtros)
            filterNombre: '',
            centropenal: '',
            departamento: '',
            SEXO: '',            
            filter2: '',                        
            motivodeceso: '',                                    
            isFilterDisabled: false,
//            searchQuery: '',
        };
    }

    // =================================================================
    // CICLO DE VIDA (Para inicializar el Layout, si Isotope aún es necesario)
    // =================================================================

    componentDidMount() {
        // Inicializa Isotope solo si es necesario para el layout (Masonry/FitRows)
        //initializeIsotopeGrid(GRID_SELECTOR);
        this.setState({ allProjects: devitems }); 
    }

    componentWillUnmount() {
        //destroyIsotopeGrid();
    }

    componentDidUpdate(prevProps, prevState) {
        // Si el número de ítems filtrados ha cambiado, refresca el layout de Isotope
/*         if (this.filterProjects(prevState) !== this.filterProjects(this.state)) {
            // Nota: Aquí tendrías que forzar el refresco del layout. 
            // Esto es más complejo en React/Isotope y a veces requiere un timeout.
            // En React moderno, Isotope se usa solo para diseño estático.
            //initializeIsotopeGrid(GRID_SELECTOR); 
        } */
    }

    // =================================================================
    // MANEJO DE ESTADO
    // =================================================================

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value }, () => {
            // Opcional: Aplicar el filtro inmediatamente después de cada cambio
            // Si quieres que el filtro se aplique solo al hacer clic en un botón, 
            // no llames a esto aquí.
        });

        //this.setState({ searchQuery: e.target.value });

    }

    handleSearch = (e) => {
        e.preventDefault();
        // Cuando el filtro está en React, solo necesitas forzar la re-renderización, 
        // lo cual ya sucede con setState. Si necesitas algo más, ponlo aquí.

/*         const query = this.state.searchQuery.trim();

        // 2. Validación: Si la cadena está vacía
        if (query === '') {
            Swal.fire({
                 text: 'Por favor, introduce un valor de búsqueda antes de filtrar.',
                icon: 'warning',
                confirmButtonText: 'Entendido',
                customClass: {
                    confirmButton: "site-button-secondry"
                },                
            });
            return; // Detiene la ejecución del filtro
        }        
 */
        this.setState({ isFilterDisabled: false });
        const newitems = this.filterProjects();
        //this.setState({ allProjects: newitems });
        this.props.onUpdateItem(newitems);
        //console.info(newitems);
        //destroyIsotopeGrid();
        //initializeIsotopeGrid(GRID_SELECTOR);
       
        
        //console.log("Filtro aplicado en React.");
    }

    // =================================================================
    // LÓGICA DE FILTRADO EN MEMORIA (CLAVE)
    // =================================================================

    filterProjects(state = this.state) {
        const { allProjects, filterNombre, centropenal, departamento, SEXO, filter2, motivodeceso } = state;
        //console.info(centropenal);
        //console.info(allProjects);
        
        // Normalizar y preparar las RegEx
        let nombreRegex = null;
        let motivoRegex = null;
        if (filterNombre) {
            try {
                // El trim() es crucial si el usuario usa espacios
                nombreRegex = new RegExp(filterNombre.trim(), 'i');
            } catch (e) {
                console.error("RegExp inválida:", e);
                return allProjects;
            }
        }

        if (motivodeceso) {
            try {
                // El trim() es crucial si el usuario usa espacios
                //console.info(motivodeceso);
                motivoRegex = new RegExp(motivodeceso.trim(), 'i');
            } catch (e) {
                //console.error("RegExp inválida motivodeceso:", e);
                return allProjects;
            }
        }        
        
        const centroLower = centropenal ? centropenal.toLowerCase().trim() : '';
        const deptoLower = departamento ? departamento.toLowerCase().trim() : '';
        const SEXOLower = SEXO ? SEXO.toLowerCase().trim() : '';
        const anioLower = filter2 ? filter2.toLowerCase().trim() : '';
        const motivodecesoLower = motivodeceso ? motivodeceso.toLowerCase().trim() : '';

        // Si no hay filtros, devuelve el array completo
        if (!nombreRegex && !centroLower && !deptoLower && !SEXOLower && !anioLower && !motivoRegex) {
            //this.setState({ allProjects: devitems });
            //this.setState({ filterNombre: '', centropenal: '', departamento: '' });
            //console.info("pasa todos los items");
            return allProjects;
        }

        return allProjects.filter(item => {

            //console.log('Type of data:', typeof item.filter2)

            // CONCATENAR TODOS LOS CAMPOS del objeto JSON/Array para la búsqueda global
            const itemAllText = [
                item.Nombre,
                item.centropenal,
                item.departamento,
                item.motivodeceso,
                // ¡Añade aquí TODOS los campos de tu JSON que deseas buscar!
            ].join(' ');

            // Lógica de Filtrado
            //console.log( item);

            // 1. matchNombre (Búsqueda GLOBAL con RegExp)
            // Busca en toda la cadena de texto del ítem.
            //const matchNombre = !nombreRegex || nombreRegex.test(itemAllText);
            const matchNombre = !nombreRegex || nombreRegex.test(item.Nombre.toLowerCase().trim());

            const itemSEXOLower = item.SEXO ? item.SEXO.toLowerCase().trim() : '';
            const matchSEXO = !SEXOLower || itemSEXOLower === SEXOLower;

            //const itemMotivoLower = item.motivodeceso ? item.motivodeceso.toLowerCase().trim() : '';
            // const matchMotivo = !motivodecesoLower || itemMotivoLower === motivodecesoLower; 
            //console.info(item.motivodeceso);
            let matchMotivo = true;
            let stMotivo = item.motivodeceso;
            if(!stMotivo){
                stMotivo = "";                    
            }
            
             matchMotivo = !motivoRegex || motivoRegex.test(stMotivo.toLowerCase().trim());
            

            //const itemAnioLower = item.filter2 ? item.filter2.toLowerCase().trim() : '';
            let itemStfilter2 = item.filter2.toString(); 
            const itemAnioLower = itemStfilter2 ? itemStfilter2.toLowerCase().trim() : '';
            const matchANIO = !anioLower || itemAnioLower === anioLower;            

            // 2. matchCentro (Comparación exacta, inclusiva)
            const itemCentroLower = item.centropenal ? item.centropenal.toLowerCase().trim() : '';
            const matchCentro = !centroLower || itemCentroLower === centroLower;
            //console.info(matchCentro +" | " + itemCentroLower +" eq "+ centroLower + " " + item.Nombre );

            // 3. matchDepto (Comparación exacta, inclusiva)
            const itemDeptoLower = item.departamento ? item.departamento.toLowerCase().trim() : '';
            const matchDepto = !deptoLower || itemDeptoLower === deptoLower;
            //console.info('match nombre' + matchNombre);
            // Retorna TRUE solo si cumple TODAS las condiciones
            const maths = { matchNombre, matchCentro, matchDepto, matchSEXO, matchANIO, matchMotivo };
            //console.info(maths);
            return matchNombre && matchCentro && matchDepto && matchSEXO && matchANIO && matchMotivo;
        });
    }

    handleReset = () => {

        // Habilitar los filtros y limpiar los campos
        // Habilitar los filtros y limpiar los campos
        this.setState({
            filterNombre: '',
            centropenal: '',
            departamento: '',
            isFilterDisabled: false, // Habilitar los filtros de nuevo
            searchGrid: false,
        }, () => {
            // Callback de setState: Se ejecuta DESPUÉS de que React ha re-renderizado
            // la lista COMPLETA (allProjects) en el DOM.

            //console.log("React: Estado reseteado y re-renderizado el DOM completo.");


            // CLAVE: Notificar a Isotope para que re-calcule el diseño de los nuevos elementos
        });

    }

    clearData = () => {
        //this.props.navigate("/");
        window.location.href = "/";
    };

    // =================================================================
    // RENDERIZADO
    // =================================================================
    //isotopeInstance.isotope({ filter: filterFunction });

    render() {
        // Llamar a la función de filtrado en el renderizado
        //const filteredProjects = this.filterProjects(); 
        //const {allProjects} = this.state;
        const { allProjects, isFilterDisabled, filterNombre, centropenal, departamento, SEXO, filter2, motivodeceso } = this.state;
        const totalResults = allProjects.length;

        const currentPath = this.props.location.pathname;

        // 2. Definir las rutas que deben ocultar el div
        const hiddenRoutes = ['/', '/registro', '/pago'];

        // 3. Lógica para determinar si el Navbar debe ocultarse
        const shouldHideNavbar = hiddenRoutes.includes(currentPath);

        // ... (Opciones de select) ...
        //console.info(filteredProjects);

        let infoText = '';
        let leyen = '';

        if (false) {
            infoText = `Resultado de busqueda: ${filterNombre} ${SEXO} ${filter2} ${centropenal} ${departamento} ( ${totalResults} resultados. )`;
            leyen = 'De click en el botón limpiar para restablecer el formulario y los datos';
/*         } else if (filterNombre || centropenal || departamento) {
            infoText = `Actualmente se muestran ${totalResults} resultados de ${this.state.allProjects.length} totales.`; */
        } else {
            //infoText = `Total de ${totalResults} proyectos cargados. Usa los filtros.`;
            infoText = ``;
        }

        return (
            <div className="section-full mobile-page-padding p-b8 bg-white bg-no-repeat bg-bottom-left" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                <div className="container">
                    <div className="section-content">

                        {shouldHideNavbar && (

                            <form onSubmit={this.handleSearch}>
                                <div class="form-row">
                                    <div class="col-md-auto"> </div>

                                    <div class="col-md-2 mb-3">
                                        {/* <label for="inputPassword" class="col-sm-2 col-form-label">FILTROS</label> */}
                                        <label></label>
                                        <fieldset disabled={isFilterDisabled}>
                                            <input type="text" name="filterNombre" value={this.state.filterNombre} onChange={this.handleChange} class="form-control quicksearch" id="quicksearch" placeholder="BUSCAR POR NOMBRE" />
                                        </fieldset>
                                    </div>
                                    <div class="col-md-2 mb-3">
                                        {/* <label for="inputPassword" class="col-sm-2 col-form-label">FILTROS</label> */}
                                        <label></label>
                                        <fieldset disabled={isFilterDisabled}>
                                            <input type="text" name="motivodeceso" value={motivodeceso} onChange={this.handleChange} class="form-control quicksearch" id="quicksearch" placeholder="BUSCAR POR MOTIVO DEL DECESO" />
                                        </fieldset>
                                    </div>                                    
                                    <div class="col mb-3">
                                        <fieldset disabled={isFilterDisabled}>
                                            <UniqueSelect
                                                data={devitems}
                                                propertyKey="SEXO"
                                                selectedValue={SEXO}
                                                onValueChange={this.handleChange}
                                            />
                                        </fieldset>
                                    </div>
{/*                                     <div class="col mb-3">
                                        <fieldset disabled={isFilterDisabled}>
                                            <UniqueSelect
                                                data={devitems}
                                                propertyKey="motivodeceso"
                                                selectedValue={motivodeceso}
                                                onValueChange={this.handleChange}
                                            />
                                        </fieldset>
                                    </div>  */}                                   
                                    <div class="col mb-3">
                                        <fieldset disabled={isFilterDisabled}>
                                            <UniqueSelect
                                                data={devitems}
                                                propertyKey="filter2"
                                                selectedValue={filter2}
                                                onValueChange={this.handleChange}
                                            />
                                        </fieldset>
                                    </div>                                                                         
                                    <div class="col mb-3">
                                        <fieldset disabled={isFilterDisabled}>
                                            <UniqueSelect
                                                data={devitems}
                                                propertyKey="centropenal"
                                                selectedValue={centropenal}
                                                onValueChange={this.handleChange}
                                            />
                                        </fieldset>
                                    </div>
                                    <div class="col-md-2 mb-3">
                                        <fieldset disabled={isFilterDisabled}>
                                            <UniqueSelect
                                                data={devitems}
                                                propertyKey="departamento"
                                                selectedValue={departamento}
                                                onValueChange={this.handleChange}
                                            />
                                        </fieldset>
                                    </div>
                                    <div class="col-md-auto">
                                        <label></label>
                                        <button type="submit" className="form-control site-button">Buscar</button>
                                        {/* <button type="button" className="site-button-secondry site-btn-effect" onClick={this.clearData}>Reset</button> <i className="fa fa-search arrow-animation" /> */}
                                    </div>
                                    <div class="col-md-auto">
                                        <label></label>
                                        <button type="button" className="form-control site-button" onClick={this.clearData}>Limpiar</button> 
                                    </div>                                    
                                </div>
                            </form>
                        )}

                        {/* FORMULARIO */}
                        {/*                 <form onSubmit={this.handleSearch}>
                    <input type="text" name="filterNombre" value={this.state.filterNombre} onChange={this.handleChange} placeholder="Nombre o búsqueda global"/>
                        <UniqueSelect 
                            data={devitems} 
                            propertyKey="centropenal" 
                            onValueChange = {this.handleChange}
                        />                          
                        <UniqueSelect 
                            data={devitems} 
                            propertyKey="departamento" 
                            onValueChange = {this.handleChange}
                        />  
                    
                    <button type="submit">Buscar ({allProjects.length} resultados)</button>
                </form> */}
                        {/* TEXTO INFORMATIVO CLAVE */}
{/*                         <div className="filter-info-box" style={{ padding: '10px', border: '1px solid #ccc' }}>
                            <strong>{infoText}</strong>
                        </div> */}
                    </div>
                </div>
{/*                 <div class="product-filter-wrap d-flex justify-content-between align-items-center m-b30">
                    <span class="woocommerce-result-count">{infoText}</span></div> */}
                <div className="section-head">
                    <div class="row">
                        <div class="col">
                        </div>
                        <div class="col-md-auto">
                        <div className="sx-separator-outer">
                            <div className="bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                                <h4 style={{fontSize: "23px", color:"#7072758c"}}>{infoText}</h4><span style={{fontSize: "15px"}}>{leyen}</span>
                            </div>
                        </div>
                        </div>
                        <div class="col">
                        </div>
                    </div>
                </div>                    
            </div>

        );
    }
};

export default withLocation(SearchableGrid);